<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>商家代采汇总详情</div>
      <el-button
        class="icon-fresh"
        size="mini"
        icon="el-icon-refresh"
        @click="fetchData(true)"
        >刷新</el-button
      >
    </div>

    <div class="c_page-title">
      <div>
        <span style="color: #666; font-size: 14px"
          >商家ID：{{ localData.supply_id }}</span
        >
        <span style="margin-left: 120px; color: #666; font-size: 14px"
          >商家：{{ localData.supply_name }}</span
        >
        <span style="margin-left: 120px; color: #666; font-size: 14px"
          >代采订单：{{ localData.woid }}</span
        >
        <span style="margin-left: 120px; color: #666; font-size: 14px"
          >代采时间：{{ localData.create_time }}</span
        >
        <span style="margin-left: 120px; color: #666; font-size: 14px"
          >市场：{{ localData.market_name }}</span
        >
      </div>
    </div>

    <el-row
      v-if="resData"
      class="row"
      :gutter="20"
      type="flex"
      align="middle"
      justify="space-around"
    >
      <el-col :span="4.8" class="column">
        <div
          :class="handleClass('getShijiListOfWcg')"
          @click="selectStatus('getShijiListOfWcg')"
        >
          实际报单
        </div>
        <div>
          {{ resData.wcg_order_info.all_num }} /
          {{ resData.wcg_order_info.all_price }}
        </div>
      </el-col>
      <el-col :span="4.8" class="column">
        <div
          :class="handleClass('getFinishListOfWcg')"
          @click="selectStatus('getFinishListOfWcg')"
        >
          已入库
        </div>
        <div>
          {{ resData.wcg_order_info.num }} /
          {{ resData.wcg_order_info.price }}
        </div>
      </el-col>
      <el-col :span="4.8" class="column">
        <div
          :class="handleClass('getRjOweListOfWcg')"
          @click="selectStatus('getRjOweListOfWcg')"
        >
          退换欠货
        </div>
        <div>
          {{ resData.wcg_order_info.rj_owe_num }} /
          {{ resData.wcg_order_info.rj_owe_price }}
        </div>
      </el-col>
      <el-col :span="4.8" class="column">
        <div
          :class="handleClass('getOweListOfWcg')"
          @click="selectStatus('getOweListOfWcg')"
        >
          代采欠货
        </div>
        <div>
          {{ resData.wcg_order_info.owe_num }} /
          {{ resData.wcg_order_info.owe_price }}
        </div>
      </el-col>
      <el-col :span="4.8" class="column">
        <div
          :class="handleClass('getDedListOfWcg')"
          @click="selectStatus('getDedListOfWcg')"
        >
          转抵扣
        </div>
        <div>
          {{ resData.wcg_order_info.ded_num }} /
          {{ resData.wcg_order_info.ded_price }}
        </div>
      </el-col>
      <el-col :span="4.8" class="column">
        <div
          :class="handleClass('getRefundListOfWcg')"
          @click="selectStatus('getRefundListOfWcg')"
        >
          已退款
        </div>
        <div>
          {{ resData.wcg_order_info.refund_num }} /
          {{ resData.wcg_order_info.refund_price }}
        </div>
      </el-col>

      <el-col :span="4.8" class="column">
        <div
          class="status"
          :class="handleClass('getBadDebtOfWcg')"
          @click="selectStatus('getBadDebtOfWcg')"
        >
          呆账
        </div>
        <div>
          {{ resData.wcg_order_info.baddebt_num }} /
          {{ resData.wcg_order_info.baddebt_price }}
        </div>
      </el-col>
      <el-col :span="4.8" class="column">
        <div
          class="status"
          :class="handleClass('getBrokenDebtOfWcg')"
          @click="selectStatus('getBrokenDebtOfWcg')"
        >
          坏账
        </div>
        <div>
          {{ resData.wcg_order_info.all_broken_num }} /
          {{ resData.wcg_order_info.all_broken_price }}
        </div>
      </el-col>
    </el-row>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
            >{{ filterFold ? "展开筛选" : "收起筛选" }}</el-button
          >
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item label="">
                  <el-input
                    v-model="form.goods_kh"
                    placeholder="款号"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item label="">
                  <el-input
                    v-model="form.goods_no"
                    placeholder="货号"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item v-if="resData.type == 8" label="分类">
                  <el-select
                    v-model="form.first_reson"
                    placeholder="一级分类"
                    @change="setResonForSearch"
                  >
                    <el-option
                      v-for="item in resData.search_reson"
                      :key="item.first.reson_text"
                      :label="item.first.reson_text"
                      :value="item.first.reson_id"
                    >
                    </el-option>
                  </el-select>
                  <el-select v-model="form.reson_id" placeholder="二级分类">
                    <el-option
                      v-for="item in resData.reson_2_s"
                      :key="item.reson_text"
                      :label="item.reson_text"
                      :value="item.reson_id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="resData.type == 8" label="状态">
                  <el-select v-model="form.status" placeholder="请选择">
                    <el-option
                      v-for="item in bdr_options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="resData.type == 8" label="通过时间：">
                  <el-date-picker
                    v-model="form.cw_audit_time"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="search">查询</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>

    <!-- 表格 -->
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>
            数据统计：<span v-if="resData" style="color: #666">{{
              resData.massage
            }}</span>
          </div>
          <el-button
            v-if="resData.need_selection > 0"
            style="margin-left: auto"
            type="success"
            size="mini"
            @click="output"
            >导出</el-button
          >
          <el-button
            v-if="resData.need_selection == 0"
            style="margin-left: auto"
            type="success"
            size="mini"
            @click="output"
            >导出</el-button
          >

          <el-dialog
            title="转坏账审核"
            :visible.sync="brokenVisible"
            width="30%"
            center
          >
            <el-form :model="form">
              <el-form-item label="备注">
                <el-input v-model="form.remark" type="textarea"></el-input>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="brokenVisible = false">取 消</el-button>
              <el-button type="primary" @click="turnToBrokenDebt">
                确 定</el-button
              >
            </div>
          </el-dialog>

          <el-dialog
            title="转呆账审核"
            :visible.sync="dialogFormVisible"
            width="30%"
            center
          >
            <el-form :model="form">
              <el-form-item label="分类">
                <el-select
                  v-model="form.first_reson"
                  placeholder="一级分类"
                  @change="setReson"
                >
                  <el-option
                    v-for="item in resData.reson"
                    :key="item.first"
                    :label="item.first"
                    :value="item.first"
                  >
                  </el-option>
                </el-select>
                <el-select v-model="form.reson_id" placeholder="二级分类">
                  <el-option
                    v-for="item in resData.reson_2"
                    :key="item.reson_text"
                    :label="item.reson_text"
                    :value="item.reson_id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="备注">
                <el-input v-model="form.remark" type="textarea"></el-input>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogFormVisible = false">取 消</el-button>
              <el-button type="primary" @click="turnToBadDebt">确 定</el-button>
            </div>
          </el-dialog>
        </div>
        <div style="margin-bottom: 0">
          <el-table
            v-if="resData"
            :key="Math.random()"
            ref="multipleTable"
            v-loading="tableLoading"
            height="600"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              v-if="resData.need_selection"
              align="right"
              type="selection"
              width="55"
            >
            </el-table-column>
            <el-table-column align="center" prop="goods_kh" label="款号">
            </el-table-column>
            <el-table-column align="center" prop="goods_no" label="货号">
            </el-table-column>
            <el-table-column
              prop="goods_name"
              label="商品名称"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="brand_name"
              label="品牌"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="goods_img"
              label="图片"
              show-overflow-tooltip
              align="center"
            >
              <template #default="scope">
                <div
                  v-viewer
                  style="
                    width: 40px;
                    height: 40px;
                    overflow: hidden;
                    cursor: pointer;
                    margin: auto;
                  "
                >
                  <img
                    :src="scope.row.goods_img"
                    alt=""
                    style="width: 100%; height: 100%"
                  />
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="co_val"
              label="颜色"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="si_val"
              label="尺码"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="price"
              label="代采单价"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="num"
              label="代采数量"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>

            <!--已入库开始-->
            <el-table-column
              v-if="resData.type == 2"
              prop="stock_in_record_where"
              label="库区"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              v-if="resData.type == 2"
              prop="stock_in_record_status"
              label="状态"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              v-if="resData.type == 2"
              prop="admin_name"
              label="入库人"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              v-if="resData.type == 2"
              prop="create_time"
              label="入库时间"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <!--已入库结束-->

            <!--转抵扣开始-->
            <el-table-column
              v-if="resData.type == 4"
              prop="status"
              label="抵扣状态"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              v-if="resData.type == 4"
              prop="w_price"
              label="抵扣金额"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              v-if="resData.type == 4"
              prop="balance"
              label="待抵扣金额"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              v-if="resData.type == 4"
              prop="ded_price"
              label="已抵扣金额"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <!--<el-table-column  prop="create_time" label="转入时间" show-overflow-tooltip align="center" v-if="resData.type == 4">-->
            <!--</el-table-column>-->
            <el-table-column
              v-if="resData.type == 4"
              prop="admin_name"
              label="操作人"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              v-if="resData.type == 4"
              prop="create_time"
              label="操作时间"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <!--转抵扣结束-->

            <!--退款开始-->
            <el-table-column
              v-if="resData.type == 5"
              prop="status"
              label="状态"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              v-if="resData.type == 5"
              prop="admin_name"
              label="操作人"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              v-if="resData.type == 5"
              prop="create_time"
              label="操作时间"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <!--坏账开始-->
            <el-table-column
              v-if="resData.type == 8"
              prop="first_reson"
              label="一级目录"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              v-if="resData.type == 8"
              prop="second_reson"
              label="二级目录"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              v-if="resData.type == 8"
              prop="remark"
              label="备注"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              v-if="resData.type == 8"
              prop="broken_debts_record_status"
              label="状态"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              v-if="resData.type == 8"
              prop="admin_name"
              label="审核人"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              v-if="resData.type == 8"
              prop="update_time"
              label="审核时间"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <!--坏账结束-->
            <!--退款结束-->
            <el-table-column
              v-if="resData.type == 6"
              prop="num"
              label="操作日志"
              show-overflow-tooltip
              align="center"
            >
              <template #default="scope">
                <el-button
                  type="text"
                  @click="getStagnantDebtDetail(scope.row)"
                >
                  操作日志</el-button
                >
                <el-dialog title="操作日志" :visible.sync="dialogTableVisible">
                  <el-table :data="gridData">
                    <el-table-column
                      property="source"
                      label="来源"
                      align="center"
                    ></el-table-column>
                    <el-table-column
                      property="status"
                      label="状态"
                      align="center"
                    ></el-table-column>
                    <el-table-column
                      property="applicant"
                      label="操作人"
                      align="center"
                    ></el-table-column>
                    <el-table-column
                      property="application_time"
                      label="申请时间"
                      align="center"
                    ></el-table-column>
                    <el-table-column
                      property="auditor"
                      label="审核人"
                      align="center"
                    ></el-table-column>
                    <el-table-column
                      property="audit_time"
                      label="审核时间"
                      align="center"
                    ></el-table-column>
                  </el-table>
                </el-dialog>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="curPage"
            background
            layout="total, prev, pager, next, jumper "
            :total="resData.pages"
            :page-size="10"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <iframe
      width="100%"
      height="3000px"
      :src="'./#/purchaseorderdetail/' + $route.params.id"
    />
  </div>
</template>

<script>
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    return {
      bdr_options: [
        {
          value: "0",
          label: "全部",
        },
        {
          value: "1",
          label: "代采审核",
        },
        {
          value: "2",
          label: "仓库审核",
        },
        {
          value: "3",
          label: "财务审核",
        },
        {
          value: "10",
          label: "申请通过",
        },
      ],
      dialogTableVisible: false,
      brokenVisible: false,
      resData: {
        need_selection: 0,
        wcg_order_info: {},
        reson_2: [],
        reson_2_s: [],
      },
      form: {
        supply_id: "",
        supply_name: "",
        start_time: "",
        end_time: "",
        first_reson: "",
        reson_id: "请选择",
        remark: "",
        is_admin: 1,
      },
      dialogFormVisible: false,
      localData: {}, // localstore存放的本地数据
      multipleSelection: [], // 多选框数据
      loading: false,
      tableLoading: false,
      url: "/erp/WcgOrder/",
      status: -1,
      curPage: 1,
      filterFold: false,
      activeName: "getShijiListOfWcg",
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      this.form.woid = this.$route.params.id;
      this.form.multipleSelection = JSON.stringify(this.multipleSelection);
      return this.form;
    },
  },
  // created() {
  //   this.fetchData();
  // },
  methods: {
    handleClass(index) {
      if (index == this.activeName) {
        return "status active";
      }
      return "status";
    },
    output() {
      this.form.is_excel = 1;
      this.$http
        .post(this.url + this.activeName, this.filteredForm)
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.form.is_excel = 0;
            if (res.data.code !== 200) {
              this.$message.error(res.data.msg);
            } else {
              window.open(apiBaseURL + res.data.data.file);
            }
          }
        });
    },
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.$http
        .post(this.url + this.activeName, this.filteredForm)
        .then((res) => {
          this.loading = false;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.resData = res.data.data;
            const dateObj = new Date();
            const emonth = dateObj.getMonth() + 1;
            const eday = dateObj.getDate();
            const eyear = dateObj.getFullYear();
            const priorTimeStamp = new Date().setDate(dateObj.getDate() - 30);
            const priorDate = new Date(priorTimeStamp);
            const smonth = priorDate.getMonth() + 1;
            const sday = priorDate.getDate();
            const syear = priorDate.getFullYear();
            const endDate = `${eyear}-${emonth}-${eday}`;
            const startDate = `${syear}-${smonth}-${sday}`;
            this.form.create_time = [startDate, endDate];

            this.localData.create_time =
              this.resData.wcg_order_info.create_time;
            this.localData.woid = this.resData.wcg_order_info.woid;
            this.localData.market_name =
              this.resData.wcg_order_info.market_name;
            this.localData.supply_id = this.resData.wcg_order_info.supply_id;
            this.localData.supply_name =
              this.resData.wcg_order_info.supply_name;
          }
        });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    handleSelectionChange(val) {
      this.multipleSelection = [];
      for (const key in val) {
        this.multipleSelection[key] = {
          id: val[key].id,
          num: val[key].num,
          price: val[key].price,
        };
      }
    },
    onSubmit() {},
    // 切换页码
    handleCurrentChange(val) {
      this.form.page = val;
      this.tableLoading = true;
      this.$http
        .post(this.url + this.activeName, this.filteredForm)
        .then((res) => {
          setTimeout(() => {
            this.tableLoading = false;
          }, 200);
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.resData = res.data.data;
          }
        });
    },
    handleClick(row) {
      this.$router.push(
        `/home/purchasing/reportdetail/${row.supply_id}/${row.supply_name}`
      );
    },
    search() {
      this.form.page = 1;
      this.loading = true;
      this.$http
        .post(this.url + this.activeName, this.filteredForm)
        .then((res) => {
          setTimeout(() => {
            this.loading = false;
          }, 200);
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.resData = res.data.data;
            for (const key in this.resData.search_reson) {
              if (
                this.form.first_reson ==
                this.resData.search_reson[key].first.reson_id
              ) {
                this.resData.reson_2_s = this.resData.search_reson[key].second;
              }
            }
            (this.status = this.filteredForm.status), (this.curPage = 1);
          }
        });
    },
    selectStatus(url) {
      this.activeName = url;
      this.loading = true;
      this.form.page = 1;
      // this.form.status = this.status = key;
      this.$http.post(`/erp/WcgOrder/${url}`, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    getStagnantDebtDetail(row) {
      this.filteredForm.worid = row.id;
      this.$http
        .post("/erp/WcgOrder/getStagnantDebtDetail", this.filteredForm)
        .then((res) => {
          setTimeout(() => {
            this.loading = false;
          }, 200);
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.gridData = res.data.data;
            this.dialogTableVisible = true;
          }
        });
    },
    // 如果为转呆账，且没有选中数据，那么toast提示“没有选中项目”
    checkField(dialog) {
      if (this.filteredForm.multipleSelection === "[]") {
        this.$alert("没有选中项目", "操作错误", {
          confirmButtonText: "确定",
          center: true,
        });
        return;
      }
      if (dialog == 1) {
        this.brokenVisible = true;
      } else if (dialog == 2) {
        this.dialogFormVisible = true;
      }
    },

    // 设置呆账原因
    setResonForSearch(value) {
      this.form.reson_id = "请选择";
      for (const key in this.resData.search_reson) {
        if (value == this.resData.search_reson[key].first.reson_id) {
          this.resData.reson_2_s = this.resData.search_reson[key].second;
        }
      }
    }, // 设置呆账原因
    setReson(value) {
      this.form.reson_id = "请选择";
      for (const key in this.resData.reson) {
        if (value == this.resData.reson[key].first) {
          this.resData.reson_2 = this.resData.reson[key].second;
        }
      }
    },
    turnToBadDebt() {
      // 检查原因是否有填写
      if (!this.form.reson_id || this.form.reson_id == "请选择") {
        this.$alert("请选择转呆账原因", "操作错误");
        return;
      }
      if (!this.form.remark) {
        this.$alert("请输入转呆账备注", "操作错误");
        return;
      }
      this.dialogFormVisible = false;
      let chosen_num = 0;
      let chosen_price = 0.0;
      for (const key in this.multipleSelection) {
        chosen_num += this.multipleSelection[key].num;
        chosen_price += +parseFloat(this.multipleSelection[key].price);
      }

      // this.$confirm('共' + chosen_num + '件，计' + chosen_price.toFixed(2) , ' 确定转为呆账？', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   center: true
      // }).then(() => {

      this.activeName = "getOweListOfWcg";
      this.loading = true;
      this.$http
        .post("/erp/WcgOrder/oweTurnToBadDebt", this.filteredForm)
        .then((res) => {
          setTimeout(() => {
            this.loading = false;
          }, 200);
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.resData = res.data.data;
            this.$message({
              type: this.resData.msg_type,
              message: this.resData.msg,
            });
          }
        });
      // }).catch(() => {
      //   this.$message({
      //   type: 'info',
      //   message: '取消操作!'
      //   });
      // });
    },
    turnToBrokenDebt() {
      // 检查原因是否有填写
      if (!this.form.remark) {
        this.$alert("请输入转坏账备注", "操作错误");
        return;
      }
      this.brokenVisible = false;
      this.activeName = "getBadDebtOfWcg";
      this.loading = true;
      this.$http
        .post("/erp/WcgOrder/beBroken", this.filteredForm)
        .then((res) => {
          setTimeout(() => {
            this.loading = false;
          }, 200);
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.resData = res.data.data;
            this.$message({
              type: this.resData.msg_type,
              message: this.resData.msg,
            });
          }
        });
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1rpx solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/PurchaseReportDetail.vue